import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const TabContent = ({ id, activeTab, children }) => {
  return activeTab === id && <div className="tab-content">{children}</div>;
};

TabContent.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default TabContent;
